import { inject, Injectable } from '@angular/core';
import { InternalGeneralService } from '../../../gen/endpoints/guardian/internal-general/internal-general.service';
import { firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { UserFrontPermissionsResponsePagedResult } from '../../../gen/interfaces/guardian';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    private generalService = inject(InternalGeneralService);
    private readonly PERMISSION_LOAD_TIMEOUT = 5000; // 5 секунд

    async getPermissions(): Promise<{ targets: string[] }> {
        try {
            const response = await firstValueFrom(
                this.generalService.getApiGeneralUserFrontPermissions().pipe(
                    timeout(this.PERMISSION_LOAD_TIMEOUT)
                )
            );
            const permissions = response as UserFrontPermissionsResponsePagedResult & { targets?: string[] };
            const legacyTargets = permissions?.targets ?? [];
            const queryableTargets = (permissions?.queryable ?? []).flatMap((item) => item?.targets ?? []);
            const targets = Array.from(new Set([...legacyTargets, ...queryableTargets]));

            if (!targets.length) {
                return { targets: [] };
            }
            return { targets };
        } catch (error) {
            console.error('Failed to load permissions:', error);
            // Возвращаем пустой список разрешений вместо отклонения promise
            // Это позволит приложению продолжить работу
            return { targets: [] };
        }
    }
}